<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">查看尺寸</div>
    <div class="order-detail-basic">
      <el-form :model="sizeMsg" label-width="130px">
        <el-form-item label="尺寸名称:">
          <span>{{ sizeMsg.sizeName }}</span>
        </el-form-item>
        <el-form-item label="页面名称:">
          <span>{{ sizeMsg.pageName }}</span>
        </el-form-item>
        <el-form-item label="匹配模板性质:">
          <span>{{ sizeMsg.spuPageName.templateProperty }}</span>
        </el-form-item>
        <el-form-item label="宽高:">
          <el-input placeholder="" v-model="sizeMsg.sizeWidth" style="width:200px" disabled>
            <template slot="prepend">宽</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="sizeMsg.sizeHeight" style="width:200px" disabled>
            <template slot="prepend">高</template>
            <template slot="append">mm</template>
          </el-input>
        </el-form-item>
        <el-form-item label="出血类型:">
          <span>{{ sizeMsg.bleed.bleedName }}</span>
        </el-form-item>
        <el-form-item label="出血:">
          <el-input placeholder="" v-model="sizeMsg.bleed.bleedTop" disabled style="width:200px;margin-bottom:10px;">
            <template slot="prepend">上方</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="sizeMsg.bleed.bleedBottom" disabled style="width:200px">
            <template slot="prepend">下方</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="sizeMsg.bleed.bleedLeft" disabled style="width:200px">
            <template slot="prepend">左侧</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="sizeMsg.bleed.bleedRight" disabled style="width:200px">
            <template slot="prepend">右侧</template>
            <template slot="append">mm</template>
          </el-input>
          <el-input placeholder="" v-model="sizeMsg.bleed.bleedIn" disabled style="width:200px">
            <template slot="prepend">内侧</template>
            <template slot="append">mm</template>
          </el-input>
          <!-- 上方:<span style="margin: 0 15px">{{sizeMsg.bleed.bleedTop}}mm</span>
          下方:<span style="margin: 0 15px">{{sizeMsg.bleed.bleedOut}}mm</span>
          内侧:<span style="margin: 0 15px">{{sizeMsg.bleed.bleedIn}}mm</span>
          外侧:<span style="margin: 0 15px">{{sizeMsg.bleed.bleedOut}}mm</span> -->
        </el-form-item>
        <el-form-item label="折线:">
          <el-table :data="HORIZONTAL" border style="width: 30%;float:left;margin-right:10px">
            <el-table-column label="水平折线">
              <template slot-scope="scope"> {{ scope.row.brokenLineValue }}mm </template>
            </el-table-column>
          </el-table>
          <el-table border :data="VERTICAL" style="width:30%">
            <el-table-column label="垂直折线">
              <template slot-scope="scope"> {{ scope.row.brokenLineValue }}mm </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="码:">
          <el-table border :data="sizeMsg.barCodeList" style="width: 50%">
            <el-table-column prop="barName" label="码名称"></el-table-column>
            <el-table-column prop="codeType" label="码类型">
              <template slot-scope="scope"> {{ scope.row.codeType === 'BAR_CODE' ? '条形码' : scope.row.codeType === 'IDENTITY' ? '标识' : scope.row.codeType === 'QR_CODE' ? '双影像二维码' : scope.row.codeType
                  === 'LOCKWIRE_BAR_CODE' ? '锁线条码' : scope.row.codeType === 'REMARK' ? '客户备注' : scope.row.codeType === 'VERTICAL_BAR_CODE' ? '上下条码' : scope.row.codeType === 'BLESSING_WALL_QR_CODE' ?
                    '祝福墙二维码' : '未定义字段'
              }} </template>
            </el-table-column>
            <el-table-column prop="address" label="码规格">
              <template v-slot='scope'>
                <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">宽度：{{ scope.row.width }}mm</p>
                <p style="fontSize:12px" v-if="scope.row.codeType !== 'IDENTITY'">高度：{{ scope.row.height }}mm</p>
                <p style=" fontSize:12px">{{ (scope.row.portrait === 'top' ? '距上：' : '距下：') + scope.row.portraitParam + 'mm' }}</p>
                <p style="fontSize:12px">{{ (scope.row.transverse === 'left' ? '距左：' : '距右：') + scope.row.transverseParam + 'mm' }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round @click="$router.go(-1)" type="primary">确定</el-button>
    </div>
  </div>
</template>
<script>
import { sizeDetail } from '@/api/pms'
export default {
  name: 'create-com-size',
  data () {
    return {
      sizeMsg: {
        bleed: {
          bleedName: ''
        }
      },
      tableData: [],
      HORIZONTAL: [],
      VERTICAL: []
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSizeMsg()
  },
  methods: {
    // 获取尺寸详情
    getSizeMsg () {
      sizeDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.sizeMsg = res.data.data
          this.sizeMsg.composeSizeBrokenLineXrefList.forEach(item => {
            this[item.brokenLineDirection].push(item)
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 65px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
